"use strict";

module.exports = {
  version: '10.1.1564'
};